'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowRightOutline = function TiArrowRightOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 35c-1.3 0-2.6-0.5-3.5-1.5s-1.5-2.2-1.5-3.5c0-1.2 0.5-1.7 1.3-3.3h-8.1c-2.7 0-5-2.3-5-5 0-2.8 2.3-5 5-5h8.1c-0.9-1.7-1.3-2.1-1.3-3.4 0-1.3 0.5-2.6 1.5-3.5 1.9-1.9 5.1-1.9 7 0l11.9 11.9-11.9 11.8c-0.9 1-2.2 1.5-3.5 1.5z m-11.8-15c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6h16.1l-5.5 5.5c-0.3 0.3-0.5 0.8-0.5 1.2 0 0.4 0.2 0.9 0.5 1.2 0.7 0.6 1.7 0.6 2.4 0l9.5-9.5-9.5-9.5c-0.7-0.7-1.7-0.7-2.4 0-0.3 0.3-0.5 0.7-0.5 1.1 0 0.5 0.2 0.9 0.5 1.2l5.5 5.5h-16.1z' })
        )
    );
};

exports.default = TiArrowRightOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-right-outline.js
// module id = 1794
// module chunks = 0